<template>
  <div class="aroma-login">
    <div class="aroma-login__header">
      <img class="aroma-login__header-bg" src="@img/header.png" />
      <img class="aroma-login__logo" src="@img/logo.png" />
    </div>

    <phone-login-view
      :phone.sync="phone"
      :code.sync="code"
      :loading="loading"
      :verify-disable="verifyDisable"
      :verify-text="verifyText"
      @verify="onVerify"
      @login="onLogin"
    />
  </div>
</template>

<script>
import API from '@/api'
import PhoneLoginView from '@/components/login/PhoneLoginView.vue'
import AromaSecondaryNav from '@/components/aroma-report/AromaSecondaryNav.vue'
import { isValidSniSn, saveSniSession } from '@/utils/sni-session'
import { getAromaEntryLocation } from '@/utils/aroma-route'
import { releaseActiveInput, resetViewportScroll } from '@/utils/viewport'

const SNI_SMS_TYPE = 20

export default {
  name: 'AromaReportLogin',

  components: {
    PhoneLoginView,
    AromaSecondaryNav
  },

  data() {
    return {
      phone: '',
      code: '',
      loading: false,
      verifyDisable: false,
      verifyText: '获取验证码',
      timer: undefined
    }
  },

  computed: {
    sn() {
      return this.$route.query.sn || ''
    },

    snText() {
      return this.sn || '未获取到设备 SN'
    },

    redirect() {
      return this.$route.query.redirect || ''
    }
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },

  methods: {
    validateSn() {
      if (!isValidSniSn(this.sn)) {
        this.$toast('设备 SN 为空')
        return false
      }
      return true
    },

    onVerify() {
      if (this.timer || !this.validateSn()) {
        return
      }
      this.sendVerifyCode()
    },

    async sendVerifyCode() {
      if (!isPhoneNumber(this.phone)) {
        this.$toast('请输入正确手机号')
        return
      }
      try {
        await API.sniSendVerifyCode({
          toPhone: this.phone,
          smsType: SNI_SMS_TYPE
        })
        this.startTimer()
      } catch (error) {
        this.$toast(error?.message || error)
      }
    },

    async onLogin() {
      if (!this.validateSn()) {
        return
      }
      if (!isPhoneNumber(this.phone)) {
        this.$toast('请输入正确手机号')
        return
      }
      if (!/^\d{6}$/.test(this.code)) {
        this.$toast('请输入6位验证码')
        return
      }

      this.loading = true
      try {
        const data = await API.sniLogin({
          phoneNumber: this.phone,
          verificationCode: this.code,
          sn: this.sn
        })
        saveSniSession(this.sn, data)
        releaseActiveInput()
        if (data.profileCompleted) {
          await this.$router.replace(getAromaEntryLocation(this.sn, this.redirect))
        } else {
          await this.$router.replace({
            name: 'AromaReportProfile',
            query: { sn: this.sn, redirect: this.redirect }
          })
        }
        resetViewportScroll()
      } catch (error) {
        this.$toast(error?.message || error)
      } finally {
        this.loading = false
      }
    },

    startTimer() {
      let timerNum = 60
      this.verifyDisable = true
      this.verifyText = timerNum + 's'
      this.timer = setInterval(() => {
        timerNum--
        if (timerNum > 0) {
          this.verifyText = timerNum + 's'
          return
        }
        clearInterval(this.timer)
        this.timer = undefined
        this.verifyDisable = false
        this.verifyText = '获取验证码'
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-login {
  width: 100%;
  min-height: 100%;
  background: #f7f7f7;

  &__header {
    width: 100%;
    height: 190px;
    position: relative;
  }

  &__header-bg {
    width: 100%;
    height: 100%;
  }

  &__logo {
    position: absolute;
    width: 83px;
    height: 80px;
    top: 64px;
    left: 147px;
  }

  &__device {
    background: #ffffff;
    border-radius: 8px;
    box-sizing: border-box;
    margin: 16px;
    padding: 16px;
  }

  &__device-title {
    color: #1f2329;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
  }

  &__device-sn {
    color: #646a73;
    font-size: 14px;
    line-height: 22px;
    margin-top: 6px;
    word-break: break-all;
  }
}
</style>
